//components
import Collapse from "components/Collapse";

//scss
import "./style.scss";

const Faq = (
	{ question_text = "", question_answer = "", query = "", theme = {} },
	...props
) => {
	return (
		<Collapse header={question_text} query={query} {...props} theme={theme}>
			{question_answer}
		</Collapse>
	);
};

export default Faq;
